import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconEsc: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconEsc"><Path fillRule="evenodd" clipRule="evenodd" d="M13 1V8H11V1H13ZM8.40972 4.77906L7.57698 5.33273C5.41886 6.76764 4 9.21834 4 12C4 16.4183 7.58172 20 12 20C16.4183 20 20 16.4183 20 12C20 9.21834 18.5811 6.76764 16.423 5.33273L15.5903 4.77906L16.6976 3.11359L17.5304 3.66727C20.2223 5.45712 22 8.52075 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 8.52075 3.77767 5.45712 6.46963 3.66727L7.30237 3.11359L8.40972 4.77906Z" fill="currentColor"/></CentralIconBase>;
});

export default IconEsc;
